export interface ILocaleService {
  transliterate(word: string): string;
}
var CyrilicDictionary = {
  А: "A",
  Б: "B",
  Ц: "C",
  Ч: "Č",
  Ћ: "Ć",
  Д: "D",
  Џ: "Dž",
  Ђ: "Đ",
  Е: "E",
  Ф: "F",
  Г: "G",
  Х: "H",
  И: "I",
  Ј: "J",
  К: "K",
  Л: "L",
  Љ: "Lj",
  М: "M",
  Н: "N",
  Њ: "Nj",
  О: "O",
  П: "P",
  Р: "R",
  С: "S",
  Ш: "Š",
  Т: "T",
  У: "U",
  В: "V",
  З: "Z",
  Ж: "Ž",
  а: "а",
  б: "б",
  ц: "ц",
  ч: "č",
  ћ: "ć",
  д: "d",
  џ: "dž",
  ђ: "đ",
  е: "e",
  ф: "f",
  г: "g",
  х: "h",
  и: "i",
  ј: "j",
  к: "k",
  л: "l",
  љ: "lj",
  м: "m",
  н: "n",
  њ: "nj",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  ш: "š",
  т: "t",
  у: "u",
  в: "v",
  з: "z",
  ж: "ž"
};

const LocaleService = (): ILocaleService => {
  return {
    transliterate(word: string) {
      word = word.trim();
      return word
        .split("")
        .map(function (char) {
          return CyrilicDictionary[char] || char;
        })
        .join("");
    }
  };
};

export { LocaleService };
